import { useEffect, useState } from 'react';
import { articles as articlesApi } from '@/api/articles';

// useDynamicPageName returns a page-name override for routes whose static
// label is too generic. Today: /sites/:slug/drafts/:id and
// /sites/:slug/articles/:id -> article title (both are the same `articles`
// resource). Returns null when no override applies; callers should fall back
// to the static page name from pageNameForPath(). The breadcrumb owns the site
// name display (read directly from SiteContext), so this hook no longer
// resolves the /sites/:slug case.
export function useDynamicPageName(pathname: string): string | null {
  const [name, setName] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    const detailMatch = /^\/sites\/[^/]+\/(?:drafts|articles)\/([^/]+)/.exec(pathname);
    if (!detailMatch || !detailMatch[1]) {
      setName(null);
      return;
    }
    const id = detailMatch[1];
    void articlesApi
      .get(id)
      .then((a) => {
        if (!cancelled) setName(a.title || a.slug);
      })
      .catch(() => {
        if (!cancelled) setName(null);
      });
    return () => {
      cancelled = true;
    };
  }, [pathname]);
  return name;
}
